import React from 'react';
import { useSecurity } from '../../helpers/SecurityHooks';
import { useParams } from 'react-router-dom';
import { appendScriptsCallback } from '../../helpers/Utils';

export function ReportPage(): React.ReactElement {
  const { area } = useParams();
  const currentSecurity = useSecurity('Shared', 'Report');
  React.useEffect(() => {
    if (currentSecurity.checkAccess()) {
      appendScriptsCallback(['Report.custom.js', 'Report.js'], 'initNewReport', { area: area });
    }
  }, [area]);
  return (
    <div className="panelcontent-section">
      <div id="sidebar-section" style={{ display: 'none' }}>
        <i className="fas fa-bars" id="sidebarBar"></i>
        <form id="form" className="k-content">
          <h3>Report Setup & Parameters</h3>
          <div id="ParametersList" className="row"></div>
          <section className="button-toolbar">
            <div className="right">
              <button id="generateReport" type="button" className="k-button k-primary" title="Go">
                Go
              </button>
            </div>
          </section>
        </form>
      </div>
      <div id="content-section" className="collapsed">
        <i className="fas fa-bars" id="contentBar" style={{ display: 'none' }}></i>
        <div id="Container" className="k-content">
          <div id="LineContent">
            <div id="LineContainer" className="spreadsheet-container"></div>
            <section className="button-toolbar">
              <div className="right">
                <button type="button" className="k-button k-primary" id="ReportButton">
                  <i className="fas fa-file-excel"></i>Download
                </button>
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
}
